import { createAction } from 'typesafe-actions'
import { TPGetComplexReport, TPGetLastSalesReport } from './api'

export const fetchReferralCode = createAction('@@Affiliates/fetchReferralCode')()
export const fetchGetQuantityReport = createAction('@@Affiliates/fetchGetQuantityReport')()
export const fetchGetComplexReport = createAction('@@Affiliates/fetchGetComplexReport')<TPGetComplexReport>()
export const fetchGetLastSalesReport = createAction('@@Affiliates/fetchGetLastSalesReport')<TPGetLastSalesReport>()
export const fetchGetTotalAmountReport = createAction('@@Affiliates/fetchGetTotalAmountReport')()
